import * as React from 'react'

import { cn } from '@/lib/utils'

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // Base styles
        'h-10 w-full min-w-0 rounded-xl border px-4 py-2 text-sm',
        // Glass effect background
        'bg-background/50 backdrop-blur-sm',
        'dark:bg-background/30',
        // Border styling
        'border-border/50 dark:border-border/30',
        // Text styling
        'placeholder:text-muted-foreground/60',
        'selection:bg-primary selection:text-primary-foreground',
        // Transitions
        'transition-all duration-200 ease-out',
        // Focus state - luminous ring
        'focus-visible:border-primary/50 focus-visible:ring-2 focus-visible:ring-primary/20',
        'focus-visible:bg-background/80 dark:focus-visible:bg-background/50',
        'outline-none',
        // File input styling
        'file:text-foreground file:inline-flex file:h-8 file:border-0 file:bg-transparent file:text-sm file:font-medium',
        // Disabled state
        'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
        // Invalid state
        'aria-invalid:border-destructive/50 aria-invalid:ring-2 aria-invalid:ring-destructive/20',
        'dark:aria-invalid:ring-destructive/30',
        className
      )}
      {...props}
    />
  )
}

export { Input }
